import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoboChat = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "RoboChat",
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16956",
		"data-name": "Group 16956",
		transform: "translate(3.75 2.5)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_12598",
			"data-name": "Path 12598",
			d: "M15.082,2A11.649,11.649,0,0,0,5.176,19.805L3,25.75l5.944-2.176A11.661,11.661,0,1,0,15.082,2h0Z",
			transform: "translate(-3 -2)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_12599",
			"data-name": "Path 12599",
			d: "M15.995,8a3.311,3.311,0,0,1,3.13,3.373c0,3.3-5.217,6-5.312,6s-5.312-2.7-5.312-6A3.311,3.311,0,0,1,11.63,8a2.815,2.815,0,0,1,2.182,1A2.81,2.81,0,0,1,15.995,8Z",
			transform: "translate(-1.625 -0.5)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12600",
		"data-name": "Path 12600",
		d: "M0,0H30V30H0Z",
		fill: "none"
	})]
});
export default SvgRoboChat;
